// extracted by mini-css-extract-plugin
module.exports = {"header":"index__header___1Cr4H","content":"index__content___3OAJ4","logo":"index__logo___2qDFi","right":"index__right___1z6zh"};